import { ColumnsCropArea, CropAreaTableStyle } from './tableStyle';
import SummaryTable from './summaryTable';



const CropAreaSummaryTable = ({ data }) => {


    return (
        <div>
            <h4 className="fw-bolder text-decoration-underline">Crop Areas</h4>
            <CropAreaTableStyle>
                <SummaryTable columns={ColumnsCropArea} data={data} tableId={'crop-areas'} />
            </CropAreaTableStyle>
        </div>
    )
}


export default CropAreaSummaryTable;